import { z } from "zod";

export type ITaskNotificationType = z.infer<typeof TTaskNotificationType>;
export const TTaskNotificationType = z.enum([
  // Basic
  "deviationDeleted",
  "deviationUpdates",
  "newDeviation",
  "nonSolvedByDeadline",
  "nonSolvedByStartDate",
  // Advanced
  "addedExecutors",
  "addedContractorGroups",
  "addedResponsibles",
  "archived",
  "category",
  "comment",
  "contractorGroups",
  "deadline",
  "files",
  "floors",
  "invoicedTo",
  "newDescription",
  "newTitle",
  "newType",
  "newCustomTaskType",
  "newTaskTypeID",
  "placeDescription",
  "priority",
  "removedContractorGroups",
  "removedExecutors",
  "removedResponsibles",
  "startDate",
  "status",
  "units",
  "updatedVisibility",
]);
